<template>
  <v-select
    v-model="fieldValue"
    outlined
    flat
    hide-details="auto"
    item-text="label"
    item-value="value"
    :items="items"
    :label="fieldLabel"
    :rules="rules"
    :menu-props="{ bottom: true, offsetY: true }"
  ></v-select>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },

    value: {
      type: String,
      required: false,
      default: ''
    }
  },

  computed: {
    fieldLabel() {
      let label = this.localize(this.item.label);

      // TODO: use enumeration
      if (this.item.fieldValidationMode === 2) {
        label += '*';
      }

      return label;
    },

    fieldValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    items() {
      const vm = this;
      return this.item.options
        .map((x) => {
          return {
            label: vm.localize(x.label),
            value: x.value
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label));
    },

    rules() {
      if (this.item.fieldValidationMode !== 2) {
        return [];
      }

      return [
        (value) => {
          if (!value || value.trim() === '') {
            return this.$t('validation.fieldIsMandatory');
          }

          return true;
        }
      ];
    }
  }
};
</script>
